import "./Footer.css";
import { useLocation, Link } from "react-router-dom";
import Navigation from "../Navigation/Navigation";
import { FaEnvelope, FaVk } from "react-icons/fa";
import { SiMax } from "react-icons/si";

function Footer({ isLogin }) {
  const location = useLocation();
  const showNav = location.pathname === "/" && !isLogin;

  const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
    navigator.userAgent
  );

  // Проверяем, является ли устройство Android
  const isAndroid = /Android/i.test(navigator.userAgent);

  // Открытие VK с правильным Intent
  const openVK = (e) => {
    if (!isMobile) return; // на десктопе стандартное поведение

    e.preventDefault();

    const vkCommunityUrl = "https://vk.com/kt_mebel";
    let redirectUrl = vkCommunityUrl;

    // Для Android используем Intent
    if (isAndroid) {
      // Формируем Intent URL, который откроет VK приложение напрямую на странице сообщества
      const intentUrl = `intent://vk.com/kt_mebel#Intent;scheme=vkontakte;package=com.vkontakte.android;S.browser_fallback_url=${encodeURIComponent(vkCommunityUrl)};end`;
      redirectUrl = intentUrl;
    }
    // Для iOS используем универсальную ссылку
    // iOS автоматически перехватывает vk.com ссылки, если приложение установлено
    else {
      // Для iOS просто используем обычную ссылку, она будет перехвачена приложением
      redirectUrl = vkCommunityUrl;
    }

    window.location.href = redirectUrl;
  };

  const openMAX = (e) => {
    if (!isMobile) return;
    e.preventDefault();

    const maxProfileUrl = "https://max.ru/u/f9LHodD0cOKK1HgyrwlY2m3ossoVzFsiEUJmVbzTDzy3d8dqFhzwCLGkLP8";
    const newWin = window.open(maxProfileUrl, "_blank");

    setTimeout(() => {
      try {
        if (!newWin || newWin.closed) {
          window.location.href = maxProfileUrl;
        }
      } catch (error) {
        window.location.href = maxProfileUrl;
      }
    }, 700);
  };

  return (
    <footer className="footer" id="address">
      <div
        className={`footer__container ${
          location.pathname === "/" ? "" : "footer__container_content"
        }`}
      >
        {/* ВЕРХ */}
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo" />
          </div>

          {showNav && <Navigation />}

          {/* СОЦСЕТИ */}
          <div className="footer__contacts">
            <a
              href="https://vk.com/kt_mebel"
              target={isMobile ? "_self" : "_blank"}
              rel="noopener noreferrer"
              aria-label="VK"
              className="footer__contact"
              onClick={openVK}
            >
              <FaVk className="footer__icon vk" />
              <span>ВКонтакте</span>
            </a>

            <a
              href="https://max.ru/u/f9LHodD0cOKK1HgyrwlY2m3ossoVzFsiEUJmVbzTDzy3d8dqFhzwCLGkLP8"
              target={isMobile ? "_self" : "_blank"}
              rel="noopener noreferrer"
              aria-label="MAX"
              className="footer__contact"
              onClick={openMAX}
            >
              <SiMax className="footer__icon max" />
              <span>MAX</span>
            </a>
          </div>
        </div>

        <hr className="footer__divider" />

        {/* НИЗ */}
        <div className="footer__bottom">
          <div className="footer__legal">
            <p className="footer__legal-name">
              Тарасов Евгений Александрович
            </p>
            <p className="footer__legal-status">
              Самозанятый (НПД), ИНН 382801892154
            </p>
            <div className="footer__legal-contacts">
              <a className="footer__legal-phone" href="tel:+79011118455">
                +7 (901) 111-84-55
              </a>

              <span className="footer__dot">•</span>

              <a className="footer__legal-email" href="mailto:ktm-online@mail.ru">
                <FaEnvelope />
                ktm-online@mail.ru
              </a>
            </div>
          </div>

          <div className="footer__info">
            <p className="footer__muted">
              Мы используем только технические cookie. Подробнее в{" "}
              <Link to="/docs/privacy" className="footer__link">
                Политике
              </Link>
              .
            </p>

            <div className="footer__docs">
              <Link to="/docs/privacy" className="footer__link">
                Политика ПДн
              </Link>

              <Link to="/docs/terms" className="footer__link">
                Пользовательское соглашение
              </Link>

              <Link to="/docs/offer" className="footer__link">
                Договор оферты
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;